import React from 'react';

export default function ServiceCard({ title, description, linkText, icon }) {
  return (
    <div className="col-12 col-md-6 col-lg-4 mb-5 d-flex">
      <div className="card align-items-center rounded-0 text-center border-0 shadow p-5 service-card">
        <div className="icon rounded my-3 p-3" style={{background: 'rgba(0, 176, 247, 0.1)', maxWidth: '100px'}}>
          <i className={`${icon} fs-1 px-2`} style={{color: '#00b0f7'}}></i>
        </div>
        <h4 className="fw-bold brand mb-3">{title}</h4>
        <p className="text-muted m-0">{description}</p>
        {/* <a href="#" className="brand text-decoration-none pt-4">{linkText}</a> */}
      </div>
    </div>
  );
}